import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-desk',
  templateUrl: './turns-desk.component.html',
  styleUrls: ['./turns-desk.component.scss']
})
export class TurnsDeskComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
